const requiredRules = (type, label) => {
  let message = '请输入' + label;

  if (
    type === 'select' ||
    type === 'cascader' ||
    type === 'radio' ||
    type === 'checkbox' ||
    type === 'rangepicker' ||
    type === 'datepicker'
  ) {
    message = '请选择' + label;
  } else if (type === 'uploader') {
    message = '请上传' + label;
  }

  return { required: true, message };
};

export { requiredRules };
